import React, { useState } from 'react';
import Layout from '../components/Layout';
import { FaGithub, FaScroll, FaTrophy, FaExternalLinkAlt } from "react-icons/fa";
import projectsData from "../data/projectsData";
import '../components/Styles/ProjectsStyles.css';

const Projects = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const categories = ['All', 'AI/ML', 'Full Stack', 'Game Dev'];

  const filteredProjects = activeCategory === 'All' 
    ? projectsData 
    : projectsData.filter(project => project.category === activeCategory);

  return (
    <Layout>
      <div className="mb-10 text-center">
        <h2 className="text-4xl font-extrabold text-white mb-2 flex justify-center items-center gap-3">
          <FaScroll className="text-yellow-500" /> Mission Log
        </h2>
        <p className="text-cyan-400 font-mono text-sm mb-6">Select a quest to view details</p>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-4 py-2 rounded-full font-mono text-sm transition-all duration-300 border ${
                activeCategory === category
                  ? 'bg-cyan-500 text-slate-900 border-cyan-500 shadow-[0_0_15px_rgba(6,182,212,0.5)]'
                  : 'bg-slate-800 text-gray-400 border-slate-700 hover:border-cyan-500 hover:text-cyan-400'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {filteredProjects.map((project, index) => (
          <div
            key={index}
            className="group relative bg-slate-800 rounded-xl overflow-hidden border border-slate-700 hover:border-cyan-500 transition-all duration-300 hover:shadow-[0_0_20px_rgba(6,182,212,0.3)] hover:-translate-y-2"
          >
            {/* Card Header / Image Placeholder */}
            <div className="h-2 bg-gradient-to-r from-cyan-500 to-blue-600"></div>
            
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="font-bold text-xl text-white group-hover:text-cyan-400 transition-colors">
                    {project.title}
                  </h3>
                  <span className="text-xs text-gray-500 font-mono">{project.category}</span>
                </div>
                <span className="bg-slate-700 text-yellow-400 text-xs px-2 py-1 rounded border border-slate-600 flex items-center gap-1">
                  <FaTrophy size={10} /> +500 XP
                </span>
              </div>
              
              <p className="text-gray-400 text-sm mb-6 line-clamp-3">
                {project.description}
              </p>
              
              <div className="flex items-center gap-3 mt-auto">
                {/* View Project Button */}
                <a
                  href={project.projectLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-cyan-600 hover:bg-cyan-500 text-white text-center py-2 rounded font-bold text-sm transition-all duration-300 active:scale-95 flex items-center justify-center gap-2"
                >
                  <FaExternalLinkAlt /> Deploy
                </a>
                
                {/* Code Button */}
                <a
                  href={project.codeLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-slate-700 hover:bg-slate-600 text-white text-center py-2 rounded font-bold text-sm transition-all duration-300 active:scale-95 flex items-center justify-center gap-2 border border-slate-600"
                >
                  <FaGithub /> Source
                </a>
              </div>
            </div>

            {/* Decorative Corner */}
            <div className="absolute top-0 right-0 w-0 h-0 border-t-[20px] border-r-[20px] border-t-transparent border-r-cyan-500/50"></div>
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default Projects;